import React from 'react'
import { Modal as ModalAnt } from 'antd'
import { ModalProps } from 'antd/lib/modal'

import { useT } from 'src/core/hooks/use-translation'

function Modal({
  cancelText = 'common.actions.cancel',
  children,
  okText = 'common.actions.save',
  title,
  ...props
}: ModalProps & { children: any }) {
  const { t } = useT()

  return (
    <ModalAnt
      {...props}
      cancelText={t(cancelText)}
      okText={t(okText)}
      title={typeof title === 'string' ? t(title) : title}
    >
      {children}
    </ModalAnt>
  )
}

export default Modal
